import { render, staticRenderFns } from "./ProbabilitySection.vue?vue&type=template&id=50e3c6bc&scoped=true"
import script from "./ProbabilitySection.vue?vue&type=script&lang=js"
export * from "./ProbabilitySection.vue?vue&type=script&lang=js"
import style0 from "./ProbabilitySection.vue?vue&type=style&index=0&id=50e3c6bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e3c6bc",
  null
  
)

export default component.exports